exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.buttons {\n  position: fixed;\n  bottom: 50px;\n  left: 350px;\n  z-index: 9;\n}\n", ""]);

// exports
